// External links used in the app.

export const onlineHelp =
  'https://kvhonboard.com/online-help/KVH_Manager/Using_Crew_Internet_Service.htm';

export const ipMobileCast = 'https://ipmobilecast.com';
